<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center04"><a id="pagev"></a><em>This is for Patrick Nielsen Hayden, for keeping the faith.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429954631_epub_ded_r1.vue?00669392